import React, { useState } from 'react';
import { Slider } from '../Slider';
import { Panel, PanelTheme } from '../Panel';

export const SliderDemo: React.FC = () => {
    // Example: full range is 0 to 100, reserved area from 0 to 20.
    const max = 100;
    const reserved = 70;
    // Initial value, must be >= reserved
    const [value, setValue] = useState(70);

    return (
        <div style={{ maxWidth: '500px' }}>
            <div style={{ marginTop: '0px', marginBottom: '20px' }}>
                <h2>Slider :</h2>
                <br />
                <Panel
                    theme={PanelTheme.White}
                    width='88%'
                >
                    <Slider
                        value={value}
                        maxAmount={max}
                        reservedAmount={reserved}
                        onValueChanged={setValue}
                    />
                </Panel>
            </div>
        </div>
    );
};
